<template>
  <div>

    <Modal class="tagsModal newModal" v-model="tagsModalShow" width="500px" 
    :mask-closable="false" :closable="false">
      <!-- title="编辑标签" -->
      <a :style="{opacity}" class="ivu-modal-close" @click="cancelTags">
        <i class="ivu-icon ivu-icon-ios-close"></i>
      </a>
      <div :style="{opacity}">
        <div class="ivu-modal-header" style="padding-left:0 !important">
          <div class="u-flex">
            <div class="ivu-modal-header-inner" style="width:auto">编辑标签</div>
            <div @click="addTag"  style="margin-left:8px" class="u-flex pot">
              <img src="@/assets/images/add.png" style="width:12px;height:12px" />
              <span class="vewlable">新增标签</span>
            </div>
          </div>

        </div>
        <div class="u-flex u-flex-wrap u-col-top " style="height:500px;  overflow: auto;     align-content: baseline;">

          <!-- <div class="u-flex add " style="margin-bottom:16px" @click="inputshow=true">
        <Icon type="md-add" />
        <div>添加</div>
      </div>
   
      <div v-if="inputshow" style="margin-bottom:16px;margin-right:12px">
        <Input @keyup.enter.native='addNewLabel' 
        v-model="newTag"
         style="width:130px" size="small" maxlength="12" show-word-limit placeholder="请输入标签" />
      </div> -->
          <template v-if="labelStoreLists.length>0">
            <div class="u-flex add " @dblclick="cretasetage(label)" @click="delSeledTag(label)" :class="[{'check': label.checkbo === true}]" style="margin-bottom:16px" v-for="(label,key) in labelStoreLists" :key="key">
              <template>
                <div>{{label.value}}</div>
                <Icon @click.stop="delStoreLabels(label)" type="md-close" />
              </template>
              <!-- <template v-else>
                <div class="tag-flex">
                  <input class="creinput" @keyup.enter="handleSearchClick(label)" v-model="label.value" />
                  <div class="tag-btn" @click="handleSearchClick(label)">确定</div>
                </div>
              </template> -->
            </div>
          </template>
          <div v-else class="mw u-flex u-row-center" style="width:100%;margin-bottom:33px">
            <img style="width:199px;height:178px;object-fit: revert;" :src="emty" />
          </div>
        </div>

      </div>
      <div class="tag-input u-flex" v-if="opacity<1">
        <div class="left-input">
          <input v-model="newTag" placeholder="请输入标签(最长为10个中文字符)" />
        </div>
        <Button @click="addNewLabel()" style="height:36px" type="primary">提交</Button>
        <Button style="height:36px;margin-left:8px" @click="clear">取消</Button>
      </div>
      <div slot="footer">
       
        <Button @click="submitTags"  type="primary" :disabled="opacity<1">提交</Button>
         <Button @click="cancelTags" :disabled="opacity<1" >取消</Button>


      </div>
    </Modal>
  </div>
</template>

<script>
  import api from "@/api";
  import ls from "store2";
  import deepcopy from "deepcopy";
  import emty from '@/assets/images/emty.png'
  export default {
    name: "tag-modal",
    props: {
      tagsModalShow: Boolean,
      curDetails: Object,
      curTags: Array,
      getDetails: Function,
    },
    computed: {
      wathered() {
        let labelStoreLists = this.labelStoreLists;
        let bo = false;
        labelStoreLists.map((item) => {
          if (item.bo) {
            bo = true;
          }
        });
        return bo;
      },
    },
    data() {
      return {
        emty,
        curDetailsCopy: {},
        newTag: "", //新增标签
        curNewTags: [], //当前选中的标签组
        selTags: [], //选择的删除标签
        isManager: false, //管理标签
        labelStoreLists: [], //标签库集合
        wrapLoading: false,
        btnLoading: false,
        inputshow: false,
        flag: false,
        opacity: 1,
        tagitem: null
      };
    },
    created() {
      this.curDetailsCopy = deepcopy(this.curDetails);
    },
    mounted() {},

    methods: {

      addTag() {
        if(this.opacity<1) return 
        this.opacity = 0.1
      },
      handleSearchClick(row) {
        const {
          id,
          type,
          value
        } = row;
        api.axss("post", "/ocm-admin/dict/updateOilSiteLabel", {
            id,
            type,
            value,
          })
          .then((res) => {

            if (res.code === "00000") {
              this.$Message.success("修改成功");
              row.bo = !row.bo;
              this.getLabels();
            } else {
              this.$Message.info(res.msg);
            }
            this.btnLoading = false;
          })
          .catch((error) => {

            this.$Message.info(res.msg);
            this.btnLoading = false;
          });
      },
      clear() {
        this.opacity = 1

        this.getLabels();
      },
      cretasetage(row) {
        // if (this.opacity < 1) {
        //   this.$Message.info("请先完成标签的修改操作")
        //   return
        // }
        this.flag = false
  
        if (row.bo) return //正在编辑


        row.bo = !row.bo;
        this.tagitem = row
        this.newTag = row.value
        this.addTag()
        //  if (!row.checkbo) { } else {
        //     this.$Message.info("已选中的标签无法编辑和删除")
        //   }
      },
      submitTags() {
        if (this.isManager) return this.$Message.info("请先完成标签库的管理操作");
        let labelStoreLists = this.$c.deepClone(this.labelStoreLists)
        labelStoreLists = labelStoreLists.filter(e => e.checkbo)
        labelStoreLists = labelStoreLists.map((item) => {
          let obj = {}
          obj["oilSiteId"] = this.curDetails.id,
           obj["oilSiteLabelId"] = item.id
          obj["oilSiteLabelName"] = item.value
          return obj
        })

        this.btnLoading = true;
        const datas = {
          oilSiteId: this.curDetails.id,
          oilSiteLabelDTOList: labelStoreLists,
        };
        api.axss("post", "/ocm-oil-site/oil-site/updateLabel", datas)
          .then((res) => {

            if (res.code === "00000") {
              this.$Message.success("提交成功");
              this.cancelTags(); // 关闭弹窗
              this.getDetails();

            }
            this.btnLoading = false;
          })
          .catch((error) => {
            this.btnLoading = false;
          });
      },
      getLabels(newTag) {
        api.axss("post", "/ocm-admin/dict/oilSiteLabelPage", {

          type: "oilSiteLabel",
          current: 1,
          size: 99,
          "gangedValueMap": {
            "tenantId": this.curDetails.tenantId
          }

        }).then((res) => {
          if (res.code === "00000") {
            let lists = res.data.records;

            lists.forEach((item, index) => {
              if (item.value === newTag) {
                this.curNewTags.push({
                  oilSiteLabelId: item.id,
                  oilSiteLabelName: item.value,
                });
              }

              // 从标签库删除已选中项
              this.curNewTags.forEach((ite) => {
                if (item.id === ite.oilSiteLabelId) {
                  lists[index].checkbo = true;
                  lists[index].hide = false; //以前的逻辑
                  //lists[index].hide = true;
                }


              });
            });
            this.labelStoreLists = lists.map((item) => {
              item.bo = false; //判断删除的逻辑
              if (!item.checkbo) {
                item.checkbo = false //判断选中的逻辑
              }

              return item;
            });
          }
        });
      },
      addNewLabel() {
        if (!this.newTag) return this.$Message.info("请填写标签名");
        if (this.newTag.length > 10) return this.$Message.info("标签文字最长为10个字符");
        this.wrapLoading = true;
        if (this.tagitem) {
          let tagitem = this.$c.deepClone(this.tagitem)
          tagitem.gangedValueMap = {
            "tenantId": this.curDetails.tenantId
          }

          tagitem.value = this.newTag
          api.axss("post", "/ocm-admin/dict/editOilSiteLabel", tagitem).then((res) => {
            if (res.code === "00000") {
              const newTagCopy = deepcopy(this.newTag);
              this.newTag = "";
              this.getLabels(newTagCopy);
              this.opacity = 1
              this.tagitem = null

            }
            this.wrapLoading = false;
          });
        } else {
          api.axss("post", "/ocm-admin/dict/editOilSiteLabel", {
            type: "oilSiteLabel",
            value: this.newTag,
            gangedValueMap: {
              "tenantId": this.curDetails.tenantId
            }
          }).then((res) => {
            if (res.code === "00000") {
              const newTagCopy = deepcopy(this.newTag);
              this.newTag = "";
              this.getLabels(newTagCopy);
              this.opacity = 1
              this.tagitem = null

            }
            this.wrapLoading = false;
          });
        }
        // let url="/ocm-admin/dict/add"
        // let value=[{
        //   type: "oilSiteLabel",
        //   value: this.newTag,
        // } ]
        // if(this.tagitem){
        //   const {id,type}=this.tagitem
        //   url='/ocm-admin/dict/updateOilSiteLabel'
        //   value={
        //      id,
        //     type,
        //     value:this.newTag,
        //   }
        // }

        // api.axss("post", url,value ).then((res) => {
        //   if (res.code === "00000") {
        //     const newTagCopy = deepcopy(this.newTag);
        //     this.newTag = "";
        //     this.getLabels(newTagCopy);
        //     this.opacity=1
        //     this.tagitem=null

        //   }
        //   this.wrapLoading = false;
        // });
      },
      delStoreLabels(row) {

        // if (row.checkbo) return this.$Message.info("所选部分标签因在别处使用无法删除 ");
        if (this.wathered)
          return this.$Message.info("请修改完标签后进行删除操作");
        // if (!this.selTags.length)
        //   return this.$Message.info("请至少选择一个标签");
        this.wrapLoading = true;
        row.tenantId = this.curDetails.tenantId
        row.oilSiteId = this.curDetails.id
        row.oilSiteLabelId = row.id
        let fronobj = {
          "tenantId": this.curDetails.tenantId,
          "oilSiteLabelId": row.id,
          "oilSiteId": this.curDetails.id
        }

        api.axss(
          "post",
          "/ocm-admin/dict/delOilSiteLabel",
          // this.selTags
          fronobj
        ).then((res) => {
          if (res.code === "00000") {
            // 剔除已选标签
            // this.selTags.forEach(item => {
            //     this.curNewTags.forEach((ite,ind) => {
            //         if(item === ite.oilSiteLabelId) this.curNewTags.splice(ind,1)
            //     })
            // })
            this.selTags = [];
            this.getLabels();
          } else {
            this.$Message.info(res.msg);
          }
          this.wrapLoading = false;
        });

        this.isManager = false
      },
      managerLabels(tag) {
        this.selTags = [];
        if (tag === "start") this.isManager = true;
        else if (tag === "finish") this.isManager = false;
      },
      selStoreTag(curItem) {
        if (curItem.checkbo) {
          return
        }
        //绑定新标签
        //更新当前标签组
        const curTag = {
          oilSiteLabelId: curItem.id,
          oilSiteLabelName: curItem.value,
        };
        // if(this.curNewTags.indexOf(curTag)<-1)
        this.curNewTags.push(curTag);
        //更改：将已经选中的标签进行上色
        // checkbo
        curItem.checkbo = true
        //去除标签池中的id
        // this.labelStoreLists.forEach((item, index) => {
        //     if (item.id === curItem.id) {
        //         this.labelStoreLists.splice(index, 1);
        //         // this.labelStoreLists[index].checked = true
        //     }
        // });
      },
      delSeledTag(row) {
        this.flag = true
        if (row.bo) return //正在编辑

        setTimeout(() => {
          if (this.flag) {
            row.checkbo = !row.checkbo
          }
        }, 300);

        //删除选中标签组
        // this.curNewTags.forEach((item, index) => {
        //   if (+item.oilSiteLabelId === +id)
        //     this.curNewTags.splice(index, 1);
        // });
        // this.getLabels();
      },
      cancelTags() {
        if (this.opacity < 1) return
        this.$emit("closetagModal", false);
        // 延迟 优化体验
        setTimeout(() => {
          // 重新管理模式
          this.isManager = false;
          // 重置已选标签
          this.curNewTags = deepcopy(this.curDetails.oilSiteLabelList);
          // 刷新标签池
          this.getLabels();
        }, 500);
      },
    },
    watch: {
      curTags: {
        handler: function(newValue, oldValue) {
          this.curNewTags = deepcopy(newValue);
          this.opacity = 1
          this.getLabels();
        },
        deep: true,
      },
    },
  };
</script>
<style>
.tagsModal .ivu-modal-wrap .ivu-modal{
  top: 20%;
}
</style>
<style lang='less'>
  .add {

    height: 22px;
    padding: 2px 6px;
    border-radius: 10px;
    opacity: 1;
    border: 1px solid #D9D9D9;
    cursor: pointer;
    margin-right: 12px;
  }

  .tag-flex {
    display: flex;
    align-items: center;

    .tag-btn {
      margin-left: 5px;
      cursor: pointer;
    }
  }

  .check {
    //选中
    background: rgba(46, 64, 187, 0.1020) !important;
    border: 1px solid rgba(46, 64, 187, 0.2000) !important;
    color: #2E40BB !important;
  }

  .creinput {
    border: 1px solid #dfdfdf;
    border: 1px solid rgba(0, 0, 0, 0);
    height: 19px;
    border-radius: 3px
  }

  .tag-input {
    position: absolute;
    top: calc(~'50% - 36px');
    height: 36px;

    .left-input {
      width: 300px;
      height: 100%;
      background: #FFFFFF;
      box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.1608);
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
      border: 1px solid #0070CC;

      input {
        width: 100%;
        height: 100%;
        padding: 8px 16px;
        border: none;

      }
    }

    .rig-btn {
      width: 56px;
      height: 100%;
      background: #0070CC;
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
      font-size: 12px;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 36px;
      text-align: center;
    }
  }

  .vewlable {
    font-size: 12px;
    margin-left: 4px;
    font-weight: normal;
    color: #0070CC;
  }
</style>